/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum DateFilterOptions {
    CUSTOM = 'customRange',
    PICKDATE = 'pickDate',
    ALL = 'all',
    PASTDAY = 'pastDay',
    PASTWEEK = 'pastWeek',
    PASTMONTH = 'pastMonth',
    PASTYEAR = 'pastYear',
    EMPTY = 'empty'
}
